import { render, staticRenderFns } from "./person-list.vue?vue&type=template&id=42be0a6e&scoped=true&"
import script from "./person-list.vue?vue&type=script&lang=js&"
export * from "./person-list.vue?vue&type=script&lang=js&"
import style0 from "./person-list.vue?vue&type=style&index=0&id=42be0a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be0a6e",
  null
  
)

export default component.exports